import { Button } from '@onchainstudios/cryptoys-common-ui';
import styles from './Success.module.css';
import { useEffect } from 'react';
import { getLegionImage } from '../../utils';
import { CRYPTOYS_LEGION_KEY } from '../../constants';
import Cube from '../../img/zoo/GenesisCube.webp';
import StatusPage from '../../components/StatusPage';

function Success() {
  useEffect(() => {
    document.title = 'Cryptoys - Thank you for your purchase';
  }, []);

  return (
    <StatusPage
      waveColor="green"
      legionImage={getLegionImage('thankYou') ?? Cube}
      contentHeading="Thank You For Your Purchase!"
      contentHeadingTag={
        <span className={styles.tagBreak}>Transaction Successful</span>
      }
      buttonCont={
        <Button
          id="backpackButton"
          data-testid="backpack-link-button"
          size="large"
          onClick={() => {
            sessionStorage.removeItem(CRYPTOYS_LEGION_KEY);
            window.location.replace(process.env.REACT_APP_BACKPACK_URL);
          }}
        >
          View Backpack
        </Button>
      }
    />
  );
}

export default Success;
